import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/thumbnails/logoOnly.png";
import Login from "../../features/public/pages/Login";
import { SHOW_PUBLIC_PROJECTS } from "../../features/public/publicVisibility";
import "./Navbar.css";
import "../../styles/brandLogo.css";
import { useEffect, useState } from "react";
import { useRef } from "react";
import { getSession, notifyAuthChanged } from "../../app/auth";

function PublicNavbar({ isAuthenticated, setAuth }) {
    const navigate = useNavigate();
    const location = useLocation();


    // ⭐ NEW: Track collapse state
    const [expanded, setExpanded] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const navRef = useRef(null);  // ⭐ new


    const closeNav = () => setExpanded(false);


    const scrollToSection = (id) => {
        closeNav(); // ⭐ Auto-close menu

        if (location.pathname === "/home" || location.pathname === "/") {
            const element = document.getElementById(id);
            if (element) element.scrollIntoView({ behavior: "smooth" });
        } else {
            navigate("/home");
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) element.scrollIntoView({ behavior: "smooth" });
            }, 500);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (expanded && navRef.current && !navRef.current.contains(event.target)) {
                setExpanded(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [expanded]);

    const handleClientPortalButton = (e) => {
        e.preventDefault();
        closeNav();

        if (getSession()) {
            navigate('/dashboard');
            return;
        }

        notifyAuthChanged();
        setShowLoginModal(true);
    };

    const session = getSession();
    const role = session?.role;
    const portalLabel = !isAuthenticated || !session
        ? "Login"
        : role === "ADMIN" || role === "SUPERADMIN"
            ? "Admin Portal"
            : "Client Portal";

    return (
        <>
            <Navbar
                ref={navRef}
                expand="lg"
                fixed="top"
                expanded={expanded}
                onToggle={() => setExpanded(!expanded)}
                className={`px-3 navbar-main fade-nav${location.pathname === "/projects" ? " public-projects-navbar" : ""}`}
                id="navbar-style"
            >
                <Container fluid>

                    <Navbar.Brand as={NavLink} to="/home" id="logo-section" onClick={closeNav}>
                        <img src={logo} alt="Logo" id="logo" className="spirent-logo d-inline-block align-top" />
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" className="hamburder-btn" />

                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-lg-auto align-items-lg-center" id="control-section">

                            <Nav.Link id="nav-item" onClick={() => scrollToSection("home")}>
                                Home
                            </Nav.Link>

                            <NavDropdown title="About" id="nav-dropdown">

                                <NavDropdown.Item onClick={() => scrollToSection("who_we_are")}>
                                    Who we are?
                                </NavDropdown.Item>

                                <NavDropdown.Item onClick={() => scrollToSection("our_purpose")}>
                                    Our purpose
                                </NavDropdown.Item>

                                <NavDropdown.Item onClick={() => scrollToSection("whyus")}>
                                    Why choose us?
                                </NavDropdown.Item>

                            </NavDropdown>

                            <Nav.Link id="nav-item" onClick={() => scrollToSection("services")}>
                                Services
                            </Nav.Link>

                            {SHOW_PUBLIC_PROJECTS && <Nav.Link as={NavLink} to="/projects" id="nav-item" onClick={closeNav}>
                                Projects
                            </Nav.Link>}

                            <Nav.Link id="nav-item" onClick={() => scrollToSection("team")}>
                                Our Team
                            </Nav.Link>

                            <Nav.Link id="nav-item" onClick={() => scrollToSection("contact_us")}>
                                Contact Us
                            </Nav.Link>

                            <NavDropdown title="More" id="nav-dropdown">
                                <NavDropdown.Item onClick={() => scrollToSection("accreditations")}>
                                    Testimonials
                                </NavDropdown.Item>
                            </NavDropdown>

                        </Nav>

                        <Nav className="ms-lg-auto align-items-lg-center">
                            <button className="animated-button" onClick={handleClientPortalButton}>
                                {portalLabel}
                            </button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {showLoginModal && (
                <Login
                    isPopup
                    onClose={() => setShowLoginModal(false)}
                    setAuth={setAuth}
                />
            )}
        </>
    );
}

export default PublicNavbar;
